function removeEcomFromPCPages() {
    const URLFragments = window.location.pathname.split('/');
    const isPCPage = URLFragments.includes('pc');
    const domain = document.body.dataset.domain;
    const isBeneluxDomain = domain ? ['nl', 'be', 'frbe'].includes(domain) : false;
    if (isPCPage && isBeneluxDomain) {
        document
            .querySelector('[data-wizard-form-store-field="product|eCommerce"]')
            ?.remove();
    }
}

export { removeEcomFromPCPages };
